export default __webpack_public_path__ + "static/media/exercise.02f41def.svg";